module.exports = "<label style=\"color: #F44336\">*</label>"